// extracted by mini-css-extract-plugin
export default {"purchaseProductList":"PurchaseProductList_purchaseProductList__756FA","metadata":"PurchaseProductList_metadata__gMaTQ"};